module.exports = __webpack_public_path__ + "media/images/poly-00fb83c4159883428995d7203c041032.png";